import React from 'react';
import { ReadsTable } from '../ReadsTable';

export const Manual: React.FC = () => {
  return <ReadsTable methodFilter="Manual" />;
};
